import { queryOptions } from '@tanstack/react-query'
import { academicTermsApi } from './api'
import { academicTermsKeys } from './keys'

export const academicTermsQueries = {
  getProgramPurseAcademicTerms: (programId: number, purseId: number) => {
    return queryOptions({
      queryKey: academicTermsKeys.programPurseAcademicTerms(programId, purseId),
      queryFn: () => {
        return academicTermsApi.getProgramAcademicTerms(programId, purseId)
      },
    })
  },

  getGlobalAcademicTerms: () => {
    return queryOptions({
      queryKey: ['global_academic_terms'],
      queryFn: () => {
        return academicTermsApi.getGlobalAcademicTerms()
      },
    })
  },
}
